import { render } from "./CampaignResults.vue?vue&type=template&id=12952e20&scoped=true"
import script from "./CampaignResults.vue?vue&type=script&lang=js"
export * from "./CampaignResults.vue?vue&type=script&lang=js"

import "./CampaignResults.vue?vue&type=style&index=0&id=12952e20&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12952e20"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QInput,QIcon,QTd,QSeparator,QTr});
